module.exports = __webpack_public_path__ + "static/media/student36.9e6a2a67.png";